import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { sanitizeReleaseNote } from '@sv-support-sdk/utils/src/helpers/sanitizeContent';
import toLocaleTime from '@sv-support-sdk/utils/src/helpers/toLocaleTime';
import { IReleaseNote } from '@sv-support-sdk/shared-types/src/common/releaseNotes';

import PageContentInner from '../../components/Layout/Page/PageContentInner';
import Collapse from '../../components/Navigation/Collapse';
import Article from '../../components/Content/Article';
import LoaderFallback from '../../components/Feedback/Loader/LoaderFallback';

import api from '../../api';
import { $l } from '../../locales';
import useMobileDetect from '../../hooks/useMobileDetect';

const ReleaseNote = () => {
  const params = useParams();
  const isMobile = useMobileDetect();
  const [releaseNote, setReleaseNote] = useState<IReleaseNote | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadNote = async () => {
      setLoading(true);

      try {
        const { data } = await api.releaseNotes.getReleaseNote(params.slug as string);

        if (data) {
          setReleaseNote({ ...data, date: toLocaleTime(data.date) });
        }
      } finally {
        setLoading(false);
      }
    };

    loadNote();
  }, [params]);

  if (loading && !releaseNote) {
    return (
      <PageContentInner height="full">
        <LoaderFallback />
      </PageContentInner>
    );
  }

  if (!releaseNote) return null;

  return (
    <PageContentInner>
      <Collapse
        icon="32--check-circle-outlined"
        title={releaseNote.header}
        subtitle={releaseNote.date}
        arrowType="text"
        isCollapsable={false}
        isMobile={isMobile}
      >
        <Article size="md" className="indent-md-top">
          <div dangerouslySetInnerHTML={sanitizeReleaseNote(releaseNote.content, {
            noteTitle: $l('HELP_CENTER_TOPIC.NOTE'),
            tipTitle: $l('HELP_CENTER_TOPIC.TIP'),
          })}></div>
        </Article>
      </Collapse>
    </PageContentInner>
  );
};

export default ReleaseNote;
